module.exports = __webpack_public_path__ + "static/qrcode-close.bf050202.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/qrcode-close.png
// module id = 1033
// module chunks = 2